import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4 flex items-center"
}
const _hoisted_2 = { class: "mt-1 flex items-center text-sm text-gray-900 sm:col-span-2 sm:mt-0 max-w-sm" }
const _hoisted_3 = { class: "ml-4 flex-shrink-0" }
const _hoisted_4 = { class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4 flex items-center" }
const _hoisted_5 = { class: "mt-1 flex items-center text-sm text-gray-900 sm:col-span-2 sm:mt-0 max-w-sm" }
const _hoisted_6 = { class: "flex-grow" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "italic"
}
const _hoisted_9 = { class: "ml-4 flex-shrink-0" }
const _hoisted_10 = { class: "mt-1 flex items-center text-sm text-gray-900 sm:col-span-2 sm:mt-0 max-w-sm" }
const _hoisted_11 = { class: "flex-grow" }
const _hoisted_12 = { class: "inline-flex flex-col items-end w-auto" }
const _hoisted_13 = { class: "ml-4 flex-shrink-0" }

import { mapRelationship, mapRelationships } from '@/store/mappers'
import { computed, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import api from '@/store/api'


export default {
  __name: 'Payment',
  props: ['checkout', 'conversationUserPair', 'markAsPaid'],
  setup(__props) {

const props = __props
const route = useRoute()

const loading = ref(false)
const stripe = window.Stripe(props.checkout.attributes.stripe_token, { apiVersion: '2019-08-14' })

const elements = stripe.elements({
  clientSecret: props.checkout.attributes.stripe_payment_intent_client_secret
})
const paymentElement = elements.create('payment', {})
onMounted(() => paymentElement.mount('#payment-element'))
const addingCard = ref(false)

const methods = computed(() => {
  const detail = mapRelationship(props.conversationUserPair?.relationships.payment_methods_detail.data)
  return mapRelationships(detail?.relationships.available_stripe_payment_methods.data)
})
const selectedMethod = ref(null)

const confirmPayment = async existing => {
  loading.value = true

  let result
  if (existing) {
    result = await stripe.confirmCardPayment(props.checkout.attributes.stripe_payment_intent_client_secret, {
      payment_method: selectedMethod.value
    })
  } else {
    result = await stripe.confirmPayment({ elements, redirect: 'if_required' })
  }

  if (result.error) {
    alert('Payment failed: ' + result.error.message)
    loading.value = false
  } else if (result.paymentIntent.status === 'succeeded') {
    refreshBottle()
  }
}

let refreshBottleAttempts = 0
const refreshBottle = () => {
  const includes = [
    'customer',
    'conversation_user_pair',
    'conversation_user_pair.payment_methods_detail',
    'conversation_user_pair.payment_methods_detail.available_stripe_payment_methods',
    'checkout',
    'checkout.taxjar_tax_summary',
    'bottle_payment',
    'stripe_payment_intent',
    'stripe_payment_intent.stripe_payment_method'
  ]
  if (!props.checkout.relationships.bottle_payment && refreshBottleAttempts < 10) {
    refreshBottleAttempts++
    setTimeout(() => {
      api.call('GET', `bottles/${route.params.id}?included=${includes.join(',')}`)
      refreshBottle()
    }, 1000)
  }
  if (props.checkout.relationships.bottle_payment) {
    loading.value = false
  }
}

return (_ctx, _cache) => {
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_BasicSpinner = _resolveComponent("BasicSpinner")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", null, [
      (props.markAsPaid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[6] || (_cache[6] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Mark as paid", -1)),
            _createElementVNode("dd", _hoisted_2, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "flex-grow" }, null, -1)),
              _createElementVNode("span", _hoisted_3, [
                _createVNode(_component_NeueButton, {
                  type: "secondary",
                  onClick: props.markAsPaid
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("Mark", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _cache[8] || (_cache[8] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Charge card on file", -1)),
        _createElementVNode("dd", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            (methods.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_SelectInput, {
                    slim: true,
                    modelValue: selectedMethod.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((selectedMethod).value = $event)),
                    placeholder: "Select a card on file",
                    options: 
                methods.value?.map(x => ({
                  name:
                    x.attributes.brand.charAt(0).toUpperCase() +
                    x.attributes.brand.slice(1) +
                    ' *' +
                    x.attributes.last4 +
                    ' ' +
                    x.attributes.exp_month +
                    '/' +
                    x.attributes.exp_year.toString().padStart(2, 0),
                  value: x.attributes.stripe_id
                }))
              
                  }, null, 8, ["modelValue", "options"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, "No cards on file"))
          ]),
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_NeueButton, {
              type: "secondary",
              onClick: _cache[1] || (_cache[1] = $event => (confirmPayment(true)))
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("Charge", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["py-2 sm:grid sm:grid-cols-3 sm:gap-4 flex", addingCard.value ? 'items-start mt-2' : 'items-center'])
      }, [
        _cache[12] || (_cache[12] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Pay with a new card", -1)),
        _createElementVNode("dd", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              _cache[10] || (_cache[10] = _createElementVNode("div", {
                id: "payment-element",
                class: "lg:w-96"
              }, null, -1)),
              _createVNode(_component_NeueButton, {
                type: "primary",
                onClick: _cache[2] || (_cache[2] = $event => (confirmPayment(false))),
                class: "mt-3"
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("Charge new card", -1)
                ]))]),
                _: 1
              })
            ], 512), [
              [_vShow, addingCard.value]
            ])
          ]),
          _createElementVNode("span", _hoisted_13, [
            _withDirectives(_createVNode(_component_NeueButton, {
              type: "secondary",
              onClick: _cache[3] || (_cache[3] = $event => (addingCard.value = true))
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("Pay", -1)
              ]))]),
              _: 1
            }, 512), [
              [_vShow, !addingCard.value]
            ])
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, !loading.value]
    ]),
    (loading.value)
      ? (_openBlock(), _createBlock(_component_BasicSpinner, {
          key: 0,
          size: "medium"
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

}